import { Box, Button, Modal, TextInput } from '@palmetto/palmetto-components';
import { useCallback, useState } from 'react';

interface ExportCongaTestCsvModalProps {
  userEmail: string;
  onClose: () => void;
  onConfirm: (email: string) => void;
}

export function ExportCongaTestCsvModal({ userEmail, onClose, onConfirm }: ExportCongaTestCsvModalProps) {
  const [email, setEmail] = useState(userEmail);

  const handleEmailChange = useCallback((e: React.ChangeEvent<HTMLInputElement>) => setEmail(e.target.value), []);

  const trimmedEmail = email.trim();
  const handleConfirm = useCallback(() => {
    onConfirm(trimmedEmail);
  }, [onConfirm, trimmedEmail]);

  return (
    <Modal ariaLabelledBy="export-conga-test-csv-modal-title" isOpen onDismiss={onClose} maxWidth="4xl">
      <Modal.Header id="export-conga-test-csv-modal-title" title="Export Conga test CSV" onDismiss={onClose} />
      <Modal.Body childGap="md" background="secondary">
        <Box as="p" fontSize="sm" color="grey-500">
          Signer emails are replaced with plus-addressed variants of this address so Conga never emails the real
          customer.
        </Box>
        <TextInput
          id="export-conga-test-email"
          label="Email"
          type="email"
          value={email}
          onChange={handleEmailChange}
        />
      </Modal.Body>
      <Modal.Footer justifyContent="flex-end" childGap="sm">
        <Button variant="secondary" tone="neutral" onClick={onClose}>
          Cancel
        </Button>
        <Button variant="primary" onClick={handleConfirm} isDisabled={!trimmedEmail}>
          Export
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
